import * as moment from 'moment';
import { Moment } from 'moment';

export class LocalLoadEvent {

  public id: string;
  public relatedEntityId: string;
  public happenedAt: Moment;
  public userId: string;
  public userEmail: string;
  public type: LocalLoadEventType;
  public oldValue: any;
  public newValue: any;
  public status: LocalLoadEventStatus;
  public errorMessage: string;


  static fromDto(data: any): LocalLoadEvent {
    const event = new LocalLoadEvent();

    if (!event) {
      return null;
    }

    event.id              = data.id;
    event.relatedEntityId = data.related_entity_id;
    event.happenedAt      = data.happened_at ? moment(data.happened_at) : null;
    event.userId          = data.user_id;
    event.userEmail       = data.user_email;
    event.type            = LocalLoadEventType.fromDto(data.type);
    event.oldValue        = data.old_value;
    event.newValue        = data.new_value;
    event.status          = data.status;
    event.errorMessage    = data.error_message;

    return event;
  }
}

export class LocalLoadEventType {

  static STATUS_UPDATE       = new LocalLoadEventType('STATUS_UPDATE', 'local-loads.events.status-update', true, true);
  static CHECK_IN            = new LocalLoadEventType('CHECK_IN', 'local-loads.events.checkin', false, true);
  static CHECK_OUT           = new LocalLoadEventType('CHECK_OUT', 'local-loads.events.checkout', false, true);
  static ETA_UPDATE          = new LocalLoadEventType('ETA_UPDATE', 'local-loads.events.eta-update', true, true);
  static MANUAL_ITEM_ADDED   = new LocalLoadEventType('MANUAL_ITEM_ADDED', 'local-loads.events.manual-item-added', false, true);
  static QUANTITY_UPDATE     = new LocalLoadEventType('QUANTITY_UPDATE', 'local-loads.events.quantity-update', true, true);
  static VEHICLE_ASSIGNATION = new LocalLoadEventType('VEHICLE_ASSIGNATION', 'local-loads.events.vehicle-assignation', true, true);
  static NOTE_CREATION       = new LocalLoadEventType('NOTE_CREATION', 'local-loads.events.note-creation', false, true);
  static POD_UPLOAD          = new LocalLoadEventType('POD_UPLOAD', 'local-loads.events.pod-upload', false, true);
  static PICTURE_UPLOAD      = new LocalLoadEventType('PICTURE_UPLOAD', 'local-loads.events.picture-upload', false, true);
  static TMS_IMPORT          = new LocalLoadEventType('TMS_IMPORT', 'local-loads.events.tms-import', false, false);
  static FILE_IMPORT         = new LocalLoadEventType('FILE_IMPORT', 'local-loads.events.file-import', false, false);
  static CANCEL_CHECK_IN     = new LocalLoadEventType('CANCEL_CHECK_IN', 'local-loads.events.cancel-checkin', false, false);

  static values(): LocalLoadEventType[] {
    return Object.getOwnPropertyNames(this)
      .map(p => Object.getOwnPropertyDescriptor(this, p))
      .filter(p => p.enumerable)
      .filter(p => p.value instanceof LocalLoadEventType)
      .map(p => p.value);
  }

  static fromDto(type: string): LocalLoadEventType {
    return this.values().find(t => t.type === type);
  }

  private constructor(public type: string, public translationKey: string, public showOldValue: boolean, public showNewValue: boolean) {
  }
}

export enum LocalLoadEventStatus {

  SUCCEED           = 'SUCCEED',
  PARTIALLY_SUCCEED = 'PARTIALLY_SUCCEED',
  FAILED            = 'FAILED'
}
